<template>
    <div class="tw:space-y-6">
        <div class="tw:grid tw:grid-cols-1 tw:sm:grid-cols-3 tw:gap-4 tw:pt-3 tw:px-6">
            <StatsCard
                :title="$t('perfil_invitaciones.total_invitaciones_temporada')"
                variant="success"
            >
                <div class="tw:flex tw:items-center tw:justify-center">
                    <span class="tw:text-3xl tw:font-bold tw:text-gray-800">
                        {{ abonado.invitaciones_abonado?.n_total_temporada || 0 }}
                    </span>
                </div>
            </StatsCard>

            <StatsCard
                :title="$t('perfil_invitaciones.invitaciones_restantes')"
                variant="primary"
            >
                <div class="tw:flex tw:items-center tw:justify-center">
                    <span class="tw:text-3xl tw:font-bold tw:text-gray-800">
                        {{ abonado.invitaciones_abonado?.n_total_disponibles || 0 }}
                    </span>
                </div>
            </StatsCard>
            <StatsCard
                :title="$t('perfil_invitaciones.invitaciones_consumidas')"
                variant="danger"
            >
                <template #default>
                    <div class="tw:flex tw:justify-center tw:gap-2">
                        <span class="tw:text-3xl tw:font-bold tw:text-gray-800">
                            {{ abonado.invitaciones_abonado?.n_total_consumidas || 0 }}
                        </span>
                        <button
                            v-if="(abonado.invitaciones_abonado?.n_total_consumidas || 0) > 0"
                            class="tw:p-0 tw:bg-transparent tw:border-0 tw:cursor-pointer tw:leading-none"
                            @click="$emit('open-modal', 'invitaciones-consumidas')"
                        >
                            <b-icon icon="info-circle-fill" class="tw:text-red-500 tw:text-xl" />
                        </button>
                    </div>
                </template>
            </StatsCard>
        </div>

        <SimpleTable
            :flat="true"
            title="Eventos disponibles para invitaciones"
            subtitle="Eventos donde puede generar invitaciones"
            :columns="columns"
            :data="items"
            :loading="loading"
            empty-text="No hay eventos disponibles para invitaciones"
            :default-col-width="defaultColWidth"
        >
            <template #cell-acciones="{ row }">
                <router-link
                    v-if="!row.all_invitaciones_consumidas"
                    :to="{ name: 'back.abonados.generar-invitaciones', params: { lista_id: lista_id, abono_id: abonado.id, event_id: row.id, sesion_id: row.sesion_id } }"
                >
                    <Button variant="primary" size="sm">
                        {{ $t('perfil_invitaciones.generar_invitaciones') }}
                    </Button>
                </router-link>
                <Button v-else variant="primary" class="tw:text-xs tw:sm:text-sm" :disabled="true">
                    {{ $t('perfil_invitaciones.invitaciones_agotadas') }}
                </Button>
            </template>
        </SimpleTable>

        <TablePagination
            v-if="totalPages > 1"
            :value="page"
            :total="total"
            :per-page="pageSize"
            @input="$emit('paginate', { page: $event })"
        />

        <ModalComponent
            :name="`invitaciones-abono-${abonado.id}`"
            :title="$t('perfil_invitaciones.invitaciones_consumidas')"
            @close="$emit('close-modal', 'invitaciones-consumidas')"
        >
            <SimpleTable
                v-if="invitacionesConsumidas && invitacionesConsumidas.length > 0"
                title="Invitaciones consumidas"
                subtitle="Registro de invitaciones utilizadas"
                :columns="columnasConsumidas"
                :data="invitacionesConsumidas"
                empty-text="No hay invitaciones consumidas"
                :default-col-width="defaultColWidth"
            />
            <div v-else class="tw:text-center tw:py-4">
                <p class="tw:text-gray-600">
                    {{ $t('perfil_invitaciones.no_invitaciones_consumidas') }}
                </p>
            </div>
        </ModalComponent>
    </div>
</template>

<script setup>
    import { computed } from 'vue'
    import Button from '@/modules/admin/ui/Button.vue'
    import Card from '@/modules/admin/ui/Card.vue'
    import StatsCard from '@/modules/admin/ui/StatsCard.vue'
    import SimpleTable from '@/modules/admin/ui/table/SimpleTable.vue'
    import TablePagination from '@/modules/admin/ui/table/TablePagination.vue'
    import ModalComponent from '@/components/backend/components/ModalComponent.vue'

    const props = defineProps({
        abonado: {
            type: Object,
            required: true
        },
        lista_id: {
            type: [String, Number],
            required: true
        },
        items: {
            type: Array,
            default: () => []
        },
        loading: {
            type: Boolean,
            default: false
        },
        page: {
            type: Number,
            default: 1
        },
        pageSize: {
            type: Number,
            default: 10
        },
        total: {
            type: Number,
            default: 0
        },
        invitacionesConsumidas: {
            type: Array,
            default: () => []
        },
        defaultColWidth: {
            type: String,
            default: '140px'
        }
    })

    const emit = defineEmits(['paginate', 'open-modal', 'close-modal'])

    const totalPages = computed(() => Math.ceil(props.total / props.pageSize))

    const columns = [
        { key: 'name', label: 'Evento', class: 'tw:w-44' },
        { key: 'start_event_date', label: 'Fecha' },
        { key: 'invitaciones_restantes', label: 'Invitaciones disponibles', class: 'tw:w-24', centered:true },
        { key: 'acciones', label: 'Opciones', class: 'tw:w-48', centered:true }
    ]

    const columnasConsumidas = [
        { key: 'evento.name', label: 'Evento' },
        { key: 'created_at', label: 'Fecha' },
        { key: 'user.name', label: 'Invitado' }
    ]
</script>
